function BreadCrumb({breadcrumbText}) {
    return (
        <div className="flex items-center justify-center breadcrumb_custom pt-[158px] pb-[106px] lg:!pt-[175px] lg:!pb-[120px]">
            <h1 className="text-[48px] lg:text-[72px] leading-[52px] lg:leading-[80px] text-white
             font-semibold">{breadcrumbText}</h1>
        </div>
    )
}

export default BreadCrumb;